"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProcessList = void 0;
const React = require("react");
const mobx_1 = require("mobx");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const ui_1 = require("client/components/ui");
const floating_page_1 = require("client/components/page/floating-page");
const throttle_debounce_1 = require("throttle-debounce");
const filter_header_1 = require("client/components/filter-header");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/users/store");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const order_1 = require("shared/order");
const permissions_1 = require("shared/permissions");
const capitalize_string_1 = require("shared/util/capitalize-string");
const moment = require("moment");
require("./payment-process.less");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
// D-002.82  // C-097.3511
const columns = [
    {
        id: "patient.lastName",
        label: "Patient",
        sortable: true,
    },
    {
        id: "site.displayName",
        numeric: false,
        label: "Pharmacy",
        sortable: false
    },
    {
        id: "order.createDate",
        label: "APPT DATE & Time",
        sortable: false
    },
    {
        id: "statusPriority.priority",
        label: "Status",
        sortable: false
    },
    {
        id: "totalDue",
        label: "Total Due",
        numeric: true,
        sortable: true
    },
    {
        id: "totalPaid",
        label: "Paid",
        numeric: true,
        sortable: true
    },
    {
        id: "balanceDue",
        label: "Balance Due",
        numeric: true,
        sortable: true
    }
];
let PaymentProcessList = class PaymentProcessList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "statusPriority.priority";
        this.filterText = "";
        this.filterDate = "";
        this.hideTitle = false;
        // For pagination // C-097 claims
        this.page = 1;
        this.limit = 100; // C-097.35 C-097.351
        this.totalPages = 1;
        this.sortedPendingOrders = null; // C-097.3511
        this.sortFrontend = (orders, orderBy, order) => {
            const getNestedValue = (obj, path) => path.split('.').reduce((acc, key) => acc === null || acc === void 0 ? void 0 : acc[key], obj);
            return [...orders].sort((a, b) => {
                let valA = getNestedValue(a, orderBy);
                let valB = getNestedValue(b, orderBy);
                if (valA == null)
                    valA = "";
                if (valB == null)
                    valB = "";
                if (typeof valA === "string" && typeof valB === "string") {
                    return order === "ASC"
                        ? valA.localeCompare(valB)
                        : valB.localeCompare(valA);
                }
                const numA = Number(valA) || 0;
                const numB = Number(valB) || 0;
                if (numA < numB)
                    return order === "ASC" ? -1 : 1;
                if (numA > numB)
                    return order === "ASC" ? 1 : -1;
                return 0;
            });
        }; // C-097.3511
        this.onRequestSort = (property) => {
            var _a;
            if (this.orderBy === property) {
                this.order = this.order === "ASC" ? "DESC" : "ASC";
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            // Fields that should be sorted on frontend
            const frontendSortableFields = ["patient.lastName", "totalDue", "totalPaid", "balanceDue"];
            const currentPageOrders = ((_a = store_1.ordersStore === null || store_1.ordersStore === void 0 ? void 0 : store_1.ordersStore.pendingOrders) === null || _a === void 0 ? void 0 : _a.value) || [];
            if (frontendSortableFields.includes(property)) {
                const sorted = this.sortFrontend(currentPageOrders, property, this.order);
                this.sortedPendingOrders = sorted;
            }
            else {
                this.sortedPendingOrders = null;
                this.loadOrders(true);
            }
        }; // C-097.3511
        this.loadOrders = throttle_debounce_1.debounce(200, (showLoading) => {
            const options = {
                count: 200,
                order: this.order,
                sort: this.orderBy,
                search: this.filterText,
                searchDate: this.filterDate,
                showCompleted: store_1.ordersStore.showCompleted.toString(),
                start: (this.page - 1) * this.limit,
                type: 0,
                page: this.page,
                limit: this.limit // C-097 Claims
            };
            store_1.ordersStore.loadpendingPayableOrders(options, showLoading).then(() => {
                store_1.ordersStore.pendingCurrentPage = this.page;
            }); // C-097.3511
        });
        this.onCallback = (value, date) => {
            this.filterText = value;
            this.filterDate = date;
            this.page = 1;
            this.sortedPendingOrders = null;
            this.loadOrders(true);
        };
        // C-097 claim // C-097.3511
        this.prevPaginationPage = () => {
            if (this.page <= 1)
                return;
            this.orderBy = "statusPriority.priority";
            this.sortedPendingOrders = null;
            this.page--;
            this.loadOrders(true);
        };
        // C-097 claim  // C-097.3511
        this.nextPaginationPage = () => {
            if (this.page >= store_1.ordersStore.totalPendingPage)
                return;
            this.orderBy = "statusPriority.priority";
            this.sortedPendingOrders = null;
            this.page++;
            this.loadOrders(true);
        };
        // C-097 claim // C-097.3511
        this.selectPaginationPage = (value) => {
            this.sortedPendingOrders = null;
            this.orderBy = "statusPriority.priority";
            this.limit = value;
            this.page = 1;
            this.loadOrders(true);
        };
        // input functionalty // C-097.3511
        this.handleKeyDown = () => {
            if (!this.page || this.page < 1)
                return;
            this.sortedPendingOrders = null;
            this.orderBy = "statusPriority.priority";
            if (this.page !== store_1.ordersStore.pendingCurrentPage) {
                this.loadOrders(true);
            }
        };
        // D-002.82
        this.toUSD = (input) => {
            const options = { currency: "USD", style: "currency" };
            const decimalStr = (input / 100).toFixed(2);
            const decimalNum = Number(decimalStr);
            const usd = decimalNum.toLocaleString("en-US", options);
            return usd;
        };
        this.renderTableRow = (row, index) => {
            const time = moment.tz(row.createDate, row.site.timezone);
            const auditUnsubmitted = row.auditStatus === order_1.AuditStatus.Unsubmitted;
            const auditPending = row.auditStatus === order_1.AuditStatus.Pending;
            const isError = row.status === order_1.OrderStatus.Error;
            const noneApprovedMsg = row.message.toLowerCase() === "no claims approved";
            const clinicErrorMessage = isError && noneApprovedMsg ? "None Approved" : "Out of Network";
            const isNotApproved = clinicErrorMessage === "None Approved";
            const isDev = store_2.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            const url = window.location.pathname; // D-002.714 D-002.55 (it allows us to navigated direct payments tab insted of claims list)
            let statusText = "Claim Status"; // This should never show up.
            switch (row.status) {
                case order_1.OrderStatus.Ready:
                    statusText = auditUnsubmitted
                        ? "Ready for Provider Review"
                        : auditPending
                            ? "Approved to Dispense"
                            : "Ready To Dispense";
                    break;
                case order_1.OrderStatus.Pending:
                    statusText = "Pending Adjudication";
                    break;
                case order_1.OrderStatus.Intended:
                    statusText = "Patient Payment Due"; // D-002.714
                    break;
                case order_1.OrderStatus.Progress:
                case order_1.OrderStatus.Executing:
                    statusText = "In Progress";
                    break;
                case order_1.OrderStatus.Reversing:
                    statusText = "Canceling";
                    break;
                case order_1.OrderStatus.Reversed:
                    statusText = "Canceled";
                    break;
                case order_1.OrderStatus.Error:
                    statusText = store_2.usersStore.permissions.ReadErrors
                        ? row.refill
                            ? "Refill Error"
                            : isNotApproved
                                ? "Ready to Cancel"
                                : "Error"
                        : clinicErrorMessage;
                    break;
                case order_1.OrderStatus.ReverseError:
                    statusText = isDev ? "Failed to Reverse" : "Pending Reversal";
                    break;
                case order_1.OrderStatus.Refill:
                    statusText = "Patient Payment Due"; // D-002.714
                    break;
                case order_1.OrderStatus.Refilled:
                    statusText = "Patient Payment Due"; // D-002.714
                    break;
                default:
                    statusText = "Patient Payment Due"; // D-002.714
                    break;
            }
            if (statusText === "None Approved")
                row.status = order_1.OrderStatus.Reversed;
            const readFailures = store_2.usersStore.permissions.ReadFailures;
            const readErrors = store_2.usersStore.permissions.ReadErrors;
            const thisOrderIsAnError = row.status === order_1.OrderStatus.Error ||
                row.status === order_1.OrderStatus.ReverseError;
            if (thisOrderIsAnError) {
                /** If the user shouldn't see any red claims, or if they don't have permission
                 * to view failure-level claims and this claim was failure-level, don't render.
                 */
                if (!readErrors ||
                    (!readFailures &&
                        (statusText === "Error" ||
                            statusText === "Failed to Reverse" ||
                            statusText === "Pending Reversal"))) {
                    return null;
                }
            }
            const oneOrMoreClaimsFailedToReverse = "One or more claims failed to reverse";
            const oneOrMoreClaimsPendingReversal = "One or more claims pending reversal";
            const rowMessage = row.message === oneOrMoreClaimsFailedToReverse
                ? isDev
                    ? row.message
                    : oneOrMoreClaimsPendingReversal
                : row.message;
            const patientName = `${row.patient.lastName}, ${row.patient.firstName}`;
            const siteName = row.site.displayName || row.site.name || CONFIG.emptyText;
            const balanceDue = this.toUSD(row.balanceDue);
            const totalDue = this.toUSD(row.totalDue);
            const paidOnDue = this.toUSD(row.totalPaid);
            // const url: string = window.location.pathname; // D-002.55 (it allows us to navigated direct payments tab insted of claims list)
            // D-002.714  D-002.55 url === '/patientPayments' // D-002.82 check condition url === '/patientPayments'
            return (React.createElement(list_item_1.MaterialListItem, { key: index, to: `/claims/${row.id}/payment` },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(patientName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: `${row.createDate ? time.format("MM/DD/YYYY hh:mm A") : ""}(${time.format("z")})` }),
                React.createElement(list_item_text_1.MaterialListItemText, { "data-tip": rowMessage, primary: React.createElement("div", { className: "orders-list__row" },
                        React.createElement("div", { className: `orders-list__status orders-list__status--due-payment` }),
                        " ",
                        React.createElement("div", { className: "orders-list__status-text" }, statusText)) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: totalDue || "0" }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: paidOnDue || "0" }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: balanceDue || "0" })));
        };
        // C-097.3511
        this.renderTable = () => {
            var _a, _b;
            let allRows = [];
            allRows = ((_a = this.sortedPendingOrders) === null || _a === void 0 ? void 0 : _a.length) ? this.sortedPendingOrders : ((_b = store_1.ordersStore === null || store_1.ordersStore === void 0 ? void 0 : store_1.ordersStore.pendingOrders) === null || _b === void 0 ? void 0 : _b.value) || [];
            return (React.createElement("div", { className: "orders__table" },
                React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: allRows, renderRow: this.renderTableRow, resizableheader: true, customClass: "custom-material-list__order-list" })));
        };
    }
    safeNumber(val) {
        const num = parseFloat(String(val).replace(/[^0-9.-]+/g, ''));
        return isNaN(num) ? 0 : num;
    } // C-097.3511
    async componentDidMount() {
        this.loadOrders(true);
        this.hideTitle = true;
        // C-097 Patients 
        this.totalPages = store_1.ordersStore.totalPendingPage;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    render() {
        var _a, _b, _c, _d;
        return (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "orders-list__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Patient Payments" })),
                React.createElement("div", null)),
            React.createElement(ui_1.UiForm, { loading: store_1.ordersStore.pendingOrders.loading },
                React.createElement(floating_page_1.FloatingPage, null,
                    React.createElement(filter_header_1.FilterHeader, { title: "Patient Payments", label: (_a = this.props.filterLabel) !== null && _a !== void 0 ? _a : "Search", withDatePicker: true, hideAdvancedFilter: true, callBack: (_b = this.props.onFilterChange) !== null && _b !== void 0 ? _b : this.onCallback, filterDate: (_c = this.props.filterDate) !== null && _c !== void 0 ? _c : this.filterDate, filterText: (_d = this.props.filterText) !== null && _d !== void 0 ? _d : this.filterText, handleToggle: this.props.toggleShowCompleted, handleToggle2: this.props.toggleShowPaidCash }),
                    this.renderTable(),
                    React.createElement("div", { className: "pagination-container-header" },
                        React.createElement("button", { className: "btn--pagination btn--pagination--right", onClick: () => this.prevPaginationPage() }, "Previous"),
                        React.createElement("div", { className: "pagination-container" },
                            React.createElement("p", null, "Page"),
                            React.createElement("div", { style: { display: "contents" } },
                                React.createElement("div", { className: "cstmPaginationInput-Wrapper" },
                                    React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pagination-input", autoFocus: true, type: "text", onChange: (e) => {
                                            const value = Number(e.target.value);
                                            if (value >= 1 && value <= store_1.ordersStore.totalPendingPage) {
                                                this.page = value;
                                            }
                                            else if (value > store_1.ordersStore.totalPendingPage) {
                                                e.target.value = this.page;
                                            }
                                        }, onKeyDownEnterPress: this.handleKeyDown, value: this.page || "" })),
                                React.createElement("div", null, "of"),
                                React.createElement("div", null, store_1.ordersStore.totalPendingPage)),
                            React.createElement("select", { className: "pagination-input", onChange: (e) => this.selectPaginationPage(e.target.value), defaultValue: this.limit },
                                React.createElement("option", { value: "5" }, "5 rows"),
                                React.createElement("option", { value: "10" }, "10 rows"),
                                React.createElement("option", { value: "25" }, "25 rows"),
                                React.createElement("option", { value: "50" }, "50 rows"),
                                React.createElement("option", { value: "100" }, "100 rows"))),
                        React.createElement("button", { className: "btn--pagination btn--pagination--left", onClick: () => this.nextPaginationPage() }, "Next")))),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" })));
    }
};
__decorate([
    mobx_1.observable
], PaymentProcessList.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], PaymentProcessList.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], PaymentProcessList.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], PaymentProcessList.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], PaymentProcessList.prototype, "hideTitle", void 0);
__decorate([
    mobx_1.observable
], PaymentProcessList.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], PaymentProcessList.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], PaymentProcessList.prototype, "totalPages", void 0);
__decorate([
    mobx_1.observable
], PaymentProcessList.prototype, "sortedPendingOrders", void 0);
PaymentProcessList = __decorate([
    mobx_react_1.observer
], PaymentProcessList);
exports.PaymentProcessList = PaymentProcessList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/payment-process/payment-process.tsx
// module id = 3115
// module chunks = 0